import track from './track';

/*
  This function is designed to provide a loose interface for tracking `module_viewed` events on the page.
  A `module_viewed` event basically indicates that a user has scrolled or landed on a visible module/section on the page.

  The `module_viewed` segment event is a common event that DSI is leveraging to track view behavior
  accross the site; this function is a wrapper to provide some guardrails and structure to the event properties.
  
  This event can also be imported into a local wrapper that extends this interface to add more specific event properties 
  for a page or set of modules on the site.

  If you have questions on what values to pass for a new implementation, please contact DSI.

  !! If you want to expand or modify this interface, please work closely with DSI to ensure consistency across the site. !!
*/

export interface TrackModuleViewedEventProperties {
  /** The name of the primary module containing the clicked element */
  module_name: string;
  /** The name of the sub-module within the primary module */
  sub_module_name?: string;
  /** The numerical index of where on the page a parent module/section is located from top to bottom */
  module_index?: number;
  /** Differentiates a sub-level within a parent module/page section */
  module_level?: number;
  /** A site identifier; e.g. 'main' */
  site?: 'main' | 'crm' | 'vet-portal' | 'instapage';
  /** The user flow or funnel context of the click; e.g. 'signup' */
  flow?: string;
  /** The direction of the scroll */
  scroll_direction?: 'vertical' | 'horizontal';
}

const eventName = 'module_viewed';

export function trackModuleViewedEvent(
  properties: TrackModuleViewedEventProperties
) {
  track(eventName, properties as unknown as Record<string, unknown>);
}

export default trackModuleViewedEvent;
